export default __webpack_public_path__ + "static/media/our-tracks.f2a10964.png";